import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import $ from 'jquery';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';

class LoginForm extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
				plp_username: '',
				password: '',     
				submitButtonDisabled: false,
				serverMessage: "",
				source:"plp"
		};

		this.handleChange = this.handleChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showforgotPwd = this.showforgotPwd.bind(this);
		this.showCreateAccount = this.showCreateAccount.bind(this);
		this.googleLogin = this.googleLogin.bind(this);

		this.myTrackerInstance = this.getTracker();
		
		this.navigationKey="PLP_Navigation"
	}

	componentDidMount(){
		this.sessionCheck();
	} 


	handleChange(e) {
		const target = e.currentTarget;	
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}

	handlePasswordChange(e) {    
		this.handleChange(e);
	}

	hmNav = function(userobj){
		//this.props.history.push('/landing');
		//console.log(this.props.myProps)
		//this.props.myProps.history.push(this.props.navigateURL);
		if(userobj && userobj.userRole.role == "PRNT"){
			if(this.props.navigateURL == "/landing"){
				window.top.location.href = "/myproducts";
			}else{
				window.top.location.href = this.props.navigateURL;
			}
		}else{
				window.top.location.href = this.props.navigateURL;
		}
		
	}

	submitForm = function(){
		var formData = {
				"userId":this.state.plp_username,
				"password":this.state.password
		}

		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.authenticated){
					console.log("response : ", response);
					//Setting user object at the browser level
					new UserStore().store(response.user);
					
					try{
						me.doLumosLogout();
					}catch(e){}
					
					me.trackMe(true,response.user);
					
					setTimeout(function(){						
						me.hmNav(response.user);
					},300);
					
					
				}else{
					if(response.message == "provider_forbidden"){						
						me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.login")});
					}else{					
						me.setState({ submitButtonDisabled: false, serverMessage: me.rb(response.message)});
					}
					//me.showAlert(me.rb("alert"),me.rb(response.message));
					me.trackMe(false);
				}
			}

			
		}

		var callBackFailure = function(response){

			console.log("response : ", response);
			me.trackMe(false);
		}

		new HmAjax(this.getUrlFor("LOGIN"),formData).post(callBackSuccess,callBackFailure);
		new UserStore().clearOldUser();
	}
	doLumosLogout(){
		var me = this;
		console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
		$.ajax({
	            url: me.getUrlFor("LUMOS_LOGOUT"),	            
	            type: 'GET',
	            xhrFields: {
			       withCredentials: true
			    },
			    crossDomain: true,
	            success: function(response){	            	
	    			
	    		},
	            error: function(response){
	    			console.log("Error in LUMOS_LOGOUT",response);
	    		}
	    });
	}
	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   


			this.submitForm();    


		}
	}
	
	trackMe(result,userObj=null){		
		var trackObj = {
				"user_id" : (userObj == null) ? "" : userObj.userId,
				"login_id" : this.state.plp_username,
				"user_agent" : navigator.userAgent,
				"platform" : navigator.platform,
				"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
				"ip_address" : "ip_address",
				"result" : (result === true),
				"session_id" : (userObj == null) ? "" : userObj.authToken
		}

		this.initiateTrack("login",trackObj);
	}
	showCreateAccount(){
		this.props.callbackCreateAccount();
	}
	showforgotPwd(){
		this.props.callbackForgotPwd(this.state.source);
	}
	googleLogin(){
		var navigateObj = {
			navigateURL:this.props.navigateURL
		}
		BrowserStorageUtil.storeSessionItem(this.navigationKey, JSON.stringify(navigateObj));
		
		window.top.location.href = this.getUrlFor("GOOGLE_LOGIN_API");
	}
	render() {
		if(this.state.loggedIn){
			return super.render();
		} else { return (
				<div id="loginRoot" className="plpLogin">
				
				<div className="container">
				
				<div className="row">
				<div className="col-md-12">

				<div className="row">
				<div className="col-md-12 mx-auto nopadding">
				<div className="rounded-0">

				<div className="text-center ">
				
				<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
				onSubmit={this.handleSubmit} noValidate>
				<FormGroup for="plp_username">

				<FormControlInput type="plp_username" className="plp_username" name="plp_username" placeholder={this.rb("login.userid")}
					value={this.state.plp_username} onChange={this.handleChange}
				required minLength={1} maxLength={270} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
					<FieldFeedbacks for="plp_username">
				<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
				<FieldFeedback when="*" />
					</FieldFeedbacks>
				</FormGroup>

				<FormGroup for="password">

				<FormControlInput type="password" className="password" name="password" placeholder={this.rb("login.password")}
					innerRef={password => this.password = password}
				value={this.state.password} onChange={this.handlePasswordChange}
				required minLength={1} maxLength={50} tabIndex="4"/>
					<FieldFeedbacks for="password" show="all">
				<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
				</FieldFeedbacks>
				</FormGroup>
				<div className="text-right forgotPassword josefinsansFont" onClick={this.showforgotPwd}>
					{this.rb("forgot_password")}
				</div>

				<div className="server-messages">{this.state.serverMessage}</div>
				
				<button disabled={this.state.submitButtonDisabled} className="submitButton">{this.rb("signin")}</button>
				</FormWithConstraints>	
				</div>
				</div>
				</div>


				</div>

				</div>
				</div>
				</div>
				
				<div className="mt-20">				
					{/*<hr className="hr-text" data-content="OR" />*/}
					<div class="text-center josefin">OR</div>
					<div className="socialLoginContainer text-center">
							
							<div className="socialLoginButtons google" onClick={this.googleLogin}>
								<i className="fab fa-google"></i>
								{this.rb("login.continuegoogle")}
							</div>
						</div>
				</div>
				
				
				<div className="text-center loginCreateNewAccount josefinsansFont" onClick={this.showCreateAccount}>
					{this.rb("login.createnewaccount")}
				</div>
				
				
			
			
				</div>
		);}
	}
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/views/login/LoginForm.js